import { Events } from "@type-r/models";
import { Linked, useEvent, useModel } from "@type-r/react";
import {
  asPercent,
  asShortCurrency,
  LinearProgress,
  PageContainer,
  PageTab,
  TransparentTabs,
  useLinkedLocation
} from "lqx-react";
import * as React from "react";
import { useEffect } from "react";
import { CategorySummary } from "src/app/pages/inmatch/api";
import { ReconciliationsPage } from "./reconciled";
import { PaymentsPage } from "./unreconciled/unreconciled";
import { Can } from "src/app/services/can";
import { UserEntitlementCatalogs, UserEntitlementCatalogValue } from "src/app/models/UserEntitlements";

export const MatchingPage = () => {
  const $category = useLinkedLocation(3, "unreconciled", "matching"),
    { value: category } = $category;

    useEffect(() => {
      if(!Can(UserEntitlementCatalogs.BankEntryView) &&
        !Can(UserEntitlementCatalogs.BankEntryWrite) &&
        !Can(UserEntitlementCatalogs.BankEntryConfirm)) {
          $category.set('reconciled');
      }
    }, []);

  return (
    <PageContainer header={<InmatchHeader $category={$category} />}>
      {category === "unreconciled" ? (
        <PaymentsPage />
      ) : category === "reconciled" ? (
        <ReconciliationsPage booked={ false } />
      ) : category === 'booked' ? (
          <ReconciliationsPage booked={ true } />
      ) : (
        <h1>Wrong path</h1>
      )}
    </PageContainer>
  );
};

const InmatchHeader = ({ $category }: { $category: Linked<string> }) => {
  const summary = useModel(CategorySummary),
    { unreconciled, reconciled, booked } = summary;

  useEffect(() => {
    summary.fetch();
  }, [$category.value]);

  useEvent(Events, "summary:refresh", () => {
    summary.fetch();
  });

  return (
    <TransparentTabs $value={$category}>
      {
          (Can(UserEntitlementCatalogs.BankEntryView) ||
          Can(UserEntitlementCatalogs.BankEntryWrite) ||
          Can(UserEntitlementCatalogs.BankEntryConfirm)) &&
        <PageTab
          value="unreconciled"
          title={`Unreconciled (${unreconciled.count})`}
          label={`${asShortCurrency(unreconciled.amount, unreconciled.currency)}`}
        />
      }

      <PageTab
        value="reconciled"
        title={`Reconciled (${reconciled.count})`}
        label={`${asShortCurrency(reconciled.amount, reconciled.currency)}`}
      >
      </PageTab>
      <PageTab
        value="booked"
        title={`Booked (${booked.count})`}
        label={`${asShortCurrency(booked.amount, booked.currency)}`}
      >
      </PageTab>
    </TransparentTabs>
  );
};
